import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import Section from '../components/Section';

export default () => (
  <Section id="contacts">
    <div className='info-container'>
      <h1><FormattedHTMLMessage id="pages:contacts:title" /></h1>
      <FormattedHTMLMessage id="pages:contacts:description" />
    </div>
    <div className='logo-container'>
      <div>Developed By:</div>
      <a href='http://www.vas.it'>
        <div className='logo' style={{ backgroundImage: 'url("images/logotypes/logo-vas.png")' }} />
      </a>
    </div>

  </Section>
);



// WEBPACK FOOTER //
// ./src/sections/Contacts.js